import { Component, OnInit } from '@angular/core';
import { ToastService } from '@kpmg-ux/ngx-tax-design-system';
import { AdminService } from 'src/app/admin/services/admin.service';
import { AppContextService } from 'src/app/core/services/app-context.service';
import { ProgressIndicatorService } from '../progress-indicator/progress-indicator.service';

@Component({
  selector: 'app-outage-message',
  templateUrl: './outage-message.component.html',
  styleUrls: ['./outage-message.component.css']
})
export class OutageMessageComponent implements OnInit {

  isActive: boolean = false;
  information: string = '';
  constructor(private adminService: AdminService, 
    private _appContext: AppContextService,
    private _toastrSvc: ToastService, private _progressIndicatorService: ProgressIndicatorService) { }

  ngOnInit() {

    this._appContext.storageSetup$.subscribe(isSetup => {
      if (isSetup) {
        this.getOutageMessage();
      }
    });

    this._appContext.refreshOutageMessage$.subscribe(isRefresh => {
     
        this.getOutageMessage();
      
    });
    
  }

  getOutageMessage() {
    this.adminService.getApplicationInfoByTag('AppMessage').subscribe(repsonse => {
      if (repsonse) {
        this.information = repsonse.information;
        this.isActive = repsonse.isActive;

      }
      // setTimeout(() => { this.startPolling(); }, 5000);

    }, error => {

      this._toastrSvc.showToastNotification({ text: 'An error occurred while fetching Application info.', appearance: 'error', isCloseable: true });
    });

  }
}
